module.exports = __webpack_public_path__ + "static/img/10-g.b6638f77.png";